import { ChangeDetectorRef, Component, Input, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-app-role',
  templateUrl: './app-role.component.html',
  styleUrls: ['./app-role.component.css']
})
export class AppRoleComponent extends BaseListCtl {
  @Input() curApp: any;
  @Input() appId: any;
  @Input() permission:any;


  activeColumns: string[] = ['name'];
  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {
    super(locator.config.get('endpoint.application.role'), locator, route);
  }

  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.name = data.name;
    form.applicationId = data.applicationId;
    form.applicationName = data.applicationName;
  }

  override ngOnInit() {
    this.preload();
    this.search();
    this.getApplications();
  }

  ngOnChanges(changes: SimpleChanges) {
    let _self = this;
    if (changes['curApp']) {
      _self.search();
      _self.getApplications();
    }
  }

  override search(): void {
    let _self = this;
    this.form.searchParams = { applicationId: Number(this.curApp['id']) };
    super.search(function (error: any) {
      if (_self.form.searchMessage === 'Record not found') {
        _self.form.list = [];
      }
    });
  }

  /**]
   * Contains applications
   */
  public applications: any = [];

  getApplications() {
    let _self = this;
    // get applications
    let url = this.locator.getEndpoint('endpoint.user') + '/applications';
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.applications = res.result.data;
    });
  }

  public editRole(id: number) {
    let _self = this;
    super.get(id, function cb() {
      // _self.getApplications();
      // _self.getUsers();
    });
  }

  makeDropdownOptions(inputArray: any, nameKey: string, valueKey: string) {
    return inputArray.map((item: any) => {
      return {
        name: item[nameKey],
        value: item[valueKey],
      };
    });
  }

  getDropdownOptions() {
    return {
      applicationId: this.makeDropdownOptions(this.applications, 'name', 'id'),
    };
  }

  getColumnLabel() {
    return { name: 'Role Name', applicationId: 'Application Name' };
  }

  handleSave(event: { row: any; callback: (isSaved: boolean) => void }) {
    let _self = this;
    const { row, callback } = event;
    row['applicationId'] = this.curApp['id'];
    row['applicationName'] = this.curApp['name'];
    console.log('New Row Saved:', row);
    this.form.data = row;
    _self.save(function () {
      callback(!_self.form.error);
    });
  }

  // handleUpdate(updatedRow: any) {
  //   console.log('Row Updated:', updatedRow);
  //   this.form.data = updatedRow;
  //   this.save();
  // }

  handleUpdate(event: { row: any; callback?: (isUpdated: boolean) => void }) {
  let _self = this;
  const { row, callback } = event;

  row['applicationId'] = this.curApp['id'];
  row['applicationName'] = this.curApp['name'];

  console.log('Row Updated:', row);

  const rowIndex = this.form['list'].findIndex(
    (data: any) => data.id === row.id
  );

  if (rowIndex !== -1) {
    this.form['list'][rowIndex] = { ...row };

    this.form['list'] = [...this.form['list']];
    this.form.data = row;

    if (callback) {
      _self.save(function () {
        callback(!_self.form.error);
      });
      setTimeout(() => {
       // _self.change1();
       this.search();
      }, 2000);
    }
  } else {
    console.error('Row not found for update');
    if (callback) callback(false);
  }
  }
  handleDelete(newRow: any) {
    this.delete(newRow.id);
  }

  getNonEditableColumns() {
    return ['applicationId'];
  }

  canCreate() {
    return this.permission?.create === 1;
  }

  canRead() {
    return this.permission?.read === 1;
  }

  canUpdate() {
    return this.permission?.update === 1;
  }

  canDelete() {
    return this.permission?.delete === 1;
  }
}
